export const MN_VALIDATION = '2.644-391.0';
